import React from 'react'
import Button from '../ui/Button'

type EmptyStateProps = {
  onAdd: () => void
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onAdd }) => {
  return (
    <div className="p-6 text-center">
      <div
        className="w-[180px] h-[120px] mx-auto my-2 mb-4 border border-dashed border-[#d0d7de] rounded-lg bg-[#F9FBFD]"
      />
      <div className="text-[#333] text-lg font-semibold">You have no Items added yet</div>
      <div className="mt-2 text-[#666] max-w-[520px] mx-auto">
        Once you add items, they will appear here, and you can use the cell management to modify your code sheet as you need
      </div>
      <div className="mt-4">
        <Button size="md" variant="primary" onClick={onAdd}>Add Item</Button>
      </div>
    </div>
  )
}

